export const COMMON_PROPS_FILE = {
    classExtra: {
        type: String,
        default: ''
    },
    accept: {
        type: String,
        default: ''
    },
    ruleFormRef: {
        type: Object,
        default: () => {
            return {}
        }
    },
    value: {
        type: [Object, String],
        default: () => {}
    },
    nameRef: {
        type: String,
        required: true,
        default: ''
    },
    errorResponse: {
        type: String,
        default: ''
    },
    limit: {
        type: Number
    },
    multiple: {
        type: Boolean,
        default: true
    },
    dataType: {
        type: String,
        default: ''
    },
    tabindex: {
        type: Number
    },
    disabled: {
        type: Boolean,
        default: false
    },
    readonly: {
        type: Boolean,
        default: false
    },
    text: {
        type: String,
        default: 'Chọn file đính kèm'
    },
    label: {
        type: String,
        default: 'Đính kèm ( ảnh / video )'
    },
    validateText: {
        type: String,
        default: 'Không thể tải file lớn hơn 5 MB !'
    },
    placeholder: {
        type: String,
        default: 'Chọn file đính kèm'
    },
    required: {
        type: Boolean,
        default: false
    },
};
